import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from '../Home/Home';
import LoginForm from '../Login/LoginForm';
import RegistrationForm from '../Register/RegistrationForm';
import ErrorPage from '../Error';
import AuthenticatedLayout from "../Content/AuthenticatedLayout";
import SecondLayout from '../Content/SecondLayout';
import Community from '../Community';
import Land from '../Land';
import Agent from '../Agent';
import Client from '../Client';
import Payments from '../Payments';
import Relationships from '../Relationships';
import PaymentMethods from '../PaymentMethods';


const AppRoute = ({ Component, Layout, ...rest }) => (
    <Route {...rest} render={props => (
        <Layout>
            <Component {...props} />
        </Layout>
    )}
    />
)


class AppHouse extends Component {
    render() {
        return (
            <Switch>
                <AppRoute exact path='/' Layout={SecondLayout} Component={LoginForm} />
                <AppRoute exact path='/land' Layout={AuthenticatedLayout} Component={Land} />
                <AppRoute exact path='/agents' Layout={AuthenticatedLayout} Component={Agent} />
                <AppRoute exact path='/clients' Layout={AuthenticatedLayout} Component={Client} />
                <AppRoute exact path='/community' Layout={AuthenticatedLayout} Component={Community} />
                <AppRoute exact path='/payments' Layout={AuthenticatedLayout} Component={Payments} />
                <AppRoute exact path='/relationships' Layout={AuthenticatedLayout} Component={Relationships} />
                <AppRoute exact path='/paymentMethods' Layout={AuthenticatedLayout} Component={PaymentMethods} />
                <AppRoute exact path='/register' Layout={SecondLayout} Component={RegistrationForm} />
                <AppRoute exact path='/home' Layout={AuthenticatedLayout} Component={Home} />
                <AppRoute exact path='*' Layout={SecondLayout} Component={ErrorPage} />
            </Switch>
        )
    }
}

export default AppHouse;


// WEBPACK FOOTER //
// ./src/Components/Entry/AppHouse.js